import { createClient } from "@supabase/supabase-js";
import { supabaseAnonKey, supabaseUrl } from "@/lib/supabase/config";

// Client anon untuk data PUBLIK (katalog `public-data.ts`, halaman produk,
// realtime status produk). Sengaja TIDAK mengelola sesi auth: tanpa opsi ini ia
// menelurkan GoTrueClient kedua pada storageKey default yang sama dengan client
// SSR storefront → warning "Multiple GoTrueClient instances" + rebutan
// navigator.locks. Query publik tak butuh sesi, jadi matikan persist/refresh.
export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: false,
          autoRefreshToken: false,
          // GoTrue mendeteksi "Multiple instances" PER storageKey
          // (nextInstanceID[storageKey]). Pakai key tersendiri agar tidak
          // bertabrakan dgn storageKey default client SSR storefront → warning
          // hilang. Tak dipakai untuk persist (persistSession:false).
          storageKey: "sb-galea-public-readonly"
        }
      })
    : null;
